import { render, staticRenderFns } from "./TeamsOverview.vue?vue&type=template&id=5b434a6b&scoped=true"
import script from "./TeamsOverview.vue?vue&type=script&lang=js"
export * from "./TeamsOverview.vue?vue&type=script&lang=js"
import style0 from "./TeamsOverview.vue?vue&type=style&index=0&id=5b434a6b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b434a6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b434a6b')) {
      api.createRecord('5b434a6b', component.options)
    } else {
      api.reload('5b434a6b', component.options)
    }
    module.hot.accept("./TeamsOverview.vue?vue&type=template&id=5b434a6b&scoped=true", function () {
      api.rerender('5b434a6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/TeamsOverview.vue"
export default component.exports